/* Variant/purchase logic is loaded only on product pages. */
(() => {
 'use strict';
 const qs=(s,root=document)=>root.querySelector(s);
 const qsa=(s,root=document)=>[...root.querySelectorAll(s)];
 const notify=message=>{const box=qs('.fl-notice');if(box){box.textContent=message;box.hidden=false;}};
  function initProduct(root = document) {
    qsa('[data-fellino-product]', root).forEach(product => {
      if (product.dataset.initialized) return;
      product.dataset.initialized = 'true';
      const text = key => product.getAttribute('data-i18n-' + key);
      const variants = JSON.parse(qs('[data-variant-data]', product).textContent);
      const form = qs('.fl-product-form', product);
      const idInput = qs('[data-variant-id]', form);
      const options = qsa('[data-product-option]', product);
      const mainAdd = qs('[data-add-to-cart]', product);
      const quantity = qs('[name="quantity"]', form);
      const price = qs('[data-product-price]', product);
      const message = qs('[data-variant-message]', product);
      const delivery = qs('[data-delivery]', product);
      let current = variants.find(v => String(v.id) === idInput.value);
      const subscription = window.FellinoFoodSubscription?.create(product, () => update(current, false));
      const showMedia = id => {
        const deferred = qs(`template[data-deferred-media="${id}"]`, product);
        if (deferred) { const fragment = deferred.content.cloneNode(true); deferred.replaceWith(fragment); }
        if (!qs(`[data-media-id="${id}"]`, product)) return;
        qsa('[data-media-id]', product).forEach(media => {
          media.hidden = media.dataset.mediaId !== String(id);
          if (media.hidden) qsa('video', media).forEach(video => video.pause());
        });
        qsa('[data-show-media]', product).forEach(button => button.setAttribute('aria-pressed', String(button.dataset.showMedia === String(id))));
      };
      // Use the existing media selection path, including deferred images and variant media.
      const mainGallery = qs('.fl-gallery-main', product);
      const mediaIds = qsa('[data-media-id], template[data-deferred-media]', mainGallery)
        .map(media => media.dataset.mediaId || media.dataset.deferredMedia);
      qsa('[data-main-gallery-step]', mainGallery).forEach(button => {
        button.hidden = mediaIds.length < 2;
        button.addEventListener('click', () => {
          const active = qs('[data-media-id]:not([hidden])', mainGallery);
          const selected = mediaIds.indexOf(active?.dataset.mediaId);
          if (selected < 0 || mediaIds.length < 2) return;
          const nextId = mediaIds[(selected + Number(button.dataset.mainGalleryStep) + mediaIds.length) % mediaIds.length];
          if (!qs(`[data-show-media="${nextId}"]`, product)) {
            const more = qs('[data-more-thumbnails]', product);
            if (more) more.replaceWith(more.content.cloneNode(true));
            const reveal = qs('[data-load-thumbnails]', product);
            if (reveal) reveal.hidden = true;
          }
          showMedia(nextId);
          const strip = qs('.fl-thumbnails', product), thumbnail = qs(`[data-show-media="${nextId}"]`, product);
          if (strip && thumbnail) strip.scrollTo({left:strip.scrollLeft + thumbnail.getBoundingClientRect().left - strip.getBoundingClientRect().left - (strip.clientWidth - thumbnail.clientWidth) / 2, behavior:'instant'});
        });
      });
      product.addEventListener('click', event => {
        const button = event.target.closest('[data-show-media]');
        if (button) showMedia(button.dataset.showMedia);
      });
      product.addEventListener('fellino:gallery:select', event => showMedia(event.detail.mediaId));
      qs('[data-load-thumbnails]', product)?.addEventListener('click', event => {
        const template = qs('[data-more-thumbnails]', product);
        if (template) template.replaceWith(template.content.cloneNode(true));
        event.currentTarget.hidden = true;
      });
      const update = (variant, pushUrl = true) => {
        current = variant;
        subscription?.sync(variant);
        const available = !!variant?.available && !subscription?.blocked();
        [mainAdd].forEach(button => {
          if (!button) return;
          button.disabled = !available;
          qs('span', button).textContent = subscription?.buttonText() || (!variant ? text('unavailable') : available ? text('add') : text('sold-out'));
        });
        idInput.disabled = !variant;
        delivery.dataset.deliveryState = variant?.deliveryState === 'digital' ? 'digital' : (variant?.available ? (variant.deliveryState || 'unknown') : 'unavailable');
        if (!variant) {
          price.replaceChildren();
          message.textContent = text('combination'); message.hidden = false;
          qs('[data-delivery] span', product).textContent = text('combination-short');
          return;
        }
        message.hidden = true;
        idInput.value = variant.id; idInput.dispatchEvent(new Event('change', {bubbles:true}));
        const displayed = subscription?.priceFor(variant) || variant;
        const discounted = displayed.compare > displayed.price;
        const row = document.createElement('div'); row.className = discounted ? 'fl-price fl-price--sale' : 'fl-price';
        const strong = document.createElement('strong'); strong.textContent = displayed.priceText; row.append(strong);
        if (discounted) { const compare = document.createElement('s'); const label=document.createElement('span');label.className='fl-sr-only';label.textContent=text('compare');compare.append(label,document.createTextNode(displayed.compareText));row.append(compare); }
        price.replaceChildren(row);
        if (displayed.unitText) { const unit = document.createElement('small'); unit.className = 'fl-unit-price'; unit.textContent = displayed.unitText; price.append(unit); }
        if (discounted) { const percent=Math.floor((displayed.compare-displayed.price)*100/displayed.compare);const summary=document.createElement('p');summary.className='fl-sale-summary';const badge=document.createElement('strong');badge.className='fl-sale-pill';badge.textContent=displayed.subscription ? `${globalThis.FellinoI18n.locale.startsWith('en') ? 'SUBSCRIPTION' : 'ABO'} −${Math.round((displayed.compare-displayed.price)*100/displayed.compare)} %` : percent>0 ? `SALE −${percent} %` : 'SALE';const saving=document.createElement('span');saving.textContent=text('savings').replace('__amount__', displayed.savingsText);summary.append(badge,saving);price.append(summary); }
        qs('[data-delivery] span', product).textContent = variant.delivery;
        qs('[data-product-sku]', product).textContent = variant.sku || '–';
        quantity.min = variant.min; quantity.step = variant.increment;
        if (variant.max !== null && variant.max !== undefined) quantity.max = variant.max; else quantity.removeAttribute('max');
        let q = Math.max(variant.min, Number(quantity.value) || variant.min);
        q = variant.min + Math.ceil((q - variant.min) / variant.increment) * variant.increment;
        quantity.value = variant.max ? Math.min(q, variant.max) : q;
        if (variant.mediaId) showMedia(variant.mediaId);
        if (pushUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
        // Standard event for existing product-option integrations. Native form submission is intentionally retained.
        document.dispatchEvent(new CustomEvent('variant:change', {detail:{variant:{...variant,id:variant.id},productId:product.dataset.productId}}));
      };
      options.forEach(option => option.addEventListener('change', () => update(variants.find(v => v.options.every((value, index) => value === options[index].value)))));
      window.addEventListener('popstate', () => {
        const id = new URL(location.href).searchParams.get('variant'); const variant = variants.find(v => String(v.id) === id);
        if (variant) { options.forEach((select, index) => select.value = variant.options[index]); update(variant, false); }
      });
      form.addEventListener('submit', event => {
        if (!current?.available) { event.preventDefault(); notify(text('select-available')); }
        if (subscription?.blocked()) event.preventDefault();
      });
      if (subscription) update(current, false);
    });
  }

 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initProduct());else initProduct();
 document.addEventListener('shopify:section:load',event=>initProduct(event.target));
})();
/* Product-only enhancements; all original image links and form controls remain fallbacks. */
(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-fellino-product]').forEach(product => {
      if (product.dataset.toolsReady) return;
      product.dataset.toolsReady = 'true';
      const text = key => product.getAttribute('data-i18n-' + key);
      product.querySelectorAll('[data-size-guide]').forEach(link => link.addEventListener('click', event => {
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault(); target.open = true;
        target.scrollIntoView({behavior:'smooth', block:'start'});
        target.querySelector('summary')?.focus({preventScroll:true});
      }));
      const dialog = product.querySelector('[data-gallery-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const images = JSON.parse(product.querySelector('[data-gallery-images]').textContent);
      if (!images.length) return;
      // Keep vertical page scrolling and browser pinch zoom available. Only a
      // deliberate horizontal finger gesture switches the product image.
      const mainGallery = product.querySelector('.fl-gallery-main');
      let mainGesture, suppressMainClickUntil = 0;
      const endMainGesture = () => {
        const active = mainGesture; mainGesture = null;
        if (active && mainGallery.hasPointerCapture(active.id)) mainGallery.releasePointerCapture(active.id);
        return active;
      };
      mainGallery?.addEventListener('pointerdown', event => {
        endMainGesture();
        if (event.pointerType !== 'touch' || !event.isPrimary || !event.target.closest('[data-gallery-open]')) return;
        mainGesture = {id:event.pointerId,x:event.clientX,y:event.clientY,time:event.timeStamp,moved:false};
      });
      mainGallery?.addEventListener('pointermove', event => {
        if (mainGesture?.id !== event.pointerId) return;
        const dx=event.clientX-mainGesture.x,dy=event.clientY-mainGesture.y;
        if (Math.hypot(dx,dy)>8) mainGesture.moved=true;
        if (Math.abs(dx)>10 && Math.abs(dx)>Math.abs(dy)*1.3 && !mainGallery.hasPointerCapture(event.pointerId)) mainGallery.setPointerCapture(event.pointerId);
      });
      mainGallery?.addEventListener('pointerup', event => {
        if (mainGesture?.id !== event.pointerId) return;
        const start=endMainGesture(),dx=event.clientX-start.x,dy=event.clientY-start.y;
        if (start.moved) suppressMainClickUntil=Date.now()+650;
        if (Math.abs(dx)<40 || Math.abs(dx)<=Math.abs(dy)*1.3 || event.timeStamp-start.time>1500 || images.length<2) return;
        const current=mainGallery.querySelector('[data-media-id]:not([hidden])');
        const selected=images.findIndex(item=>String(item.id)===current?.dataset.mediaId);
        if (selected<0) return;
        const next=images[(selected+(dx<0?1:-1)+images.length)%images.length];
        if (!product.querySelector(`[data-show-media="${next.id}"]`)) {
          const more=product.querySelector('[data-more-thumbnails]');
          if (more) more.replaceWith(more.content.cloneNode(true));
          const button=product.querySelector('[data-load-thumbnails]');if(button)button.hidden=true;
        }
        product.dispatchEvent(new CustomEvent('fellino:gallery:select',{detail:{mediaId:next.id}}));
        const strip=product.querySelector('.fl-thumbnails'),thumb=product.querySelector(`[data-show-media="${next.id}"]`);
        if(strip&&thumb)strip.scrollTo({left:strip.scrollLeft+thumb.getBoundingClientRect().left-strip.getBoundingClientRect().left-(strip.clientWidth-thumb.clientWidth)/2,behavior:'instant'});
      });
      mainGallery?.addEventListener('pointercancel', () => {suppressMainClickUntil=Date.now()+650;endMainGesture();});
      mainGallery?.addEventListener('lostpointercapture', event => {
        // Touch starts with implicit capture on the image. Its bubbling loss
        // when capture transfers to the gallery must not cancel the gesture.
        if(event.target===mainGallery && mainGesture?.id===event.pointerId && !mainGallery.hasPointerCapture(event.pointerId))endMainGesture();
      });
      mainGallery?.addEventListener('click', event => {
        if(Date.now()<suppressMainClickUntil){event.preventDefault();event.stopPropagation();}
      },true);
      const image = dialog.querySelector('[data-gallery-image]');
      const stage = dialog.querySelector('[data-gallery-stage]');
      const zoom = dialog.querySelector('[data-gallery-zoom]');
      let index = 0, opener, previousOverflow = '', suppressClickUntil = 0, gesture;
      const endGesture = () => {
        const active = gesture; gesture = null;
        stage.classList.remove('is-panning');
        if (active && stage.hasPointerCapture(active.id)) stage.releasePointerCapture(active.id);
        return active;
      };
      const thumbnails = () => [...dialog.querySelectorAll('[data-gallery-thumb]')];
      const revealThumbnail = () => {
        const strip = dialog.querySelector('[data-gallery-thumbnails]');
        const selected = dialog.querySelector('[data-gallery-thumb][aria-current="true"]');
        if (strip && selected) strip.scrollTo({left:selected.offsetLeft - strip.offsetLeft - (strip.clientWidth - selected.clientWidth) / 2, behavior:'instant'});
      };
      const setZoom = enabled => {
        endGesture();
        dialog.classList.toggle('is-zoomed', enabled);
        image.setAttribute('aria-pressed', String(enabled));
        image.setAttribute('aria-label', enabled ? text('zoom-out') : text('zoom-in'));
        zoom?.setAttribute('aria-pressed', String(enabled));
        zoom?.setAttribute('aria-label', enabled ? text('zoom-out') : text('zoom-in'));
        stage.scrollTo(0,0);
      };
      const show = requested => {
        index = ((requested % images.length) + images.length) % images.length; setZoom(false);
        image.src = images[index].src; image.alt = images[index].alt;
        dialog.querySelector('[data-gallery-caption]').textContent = `${index + 1} / ${images.length}`;
        dialog.querySelectorAll('[data-gallery-prev],[data-gallery-next]').forEach(button => { button.disabled = images.length < 2; button.hidden = images.length < 2; });
        thumbnails().forEach(button => {
          const active = button.dataset.galleryThumb === String(images[index].id);
          button.tabIndex = active ? 0 : -1;
          if (active) button.setAttribute('aria-current','true');
          else button.removeAttribute('aria-current');
        });
        if (dialog.open) revealThumbnail();
      };
      product.addEventListener('click', event => {
        const link = event.target.closest('[data-gallery-open]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const selected = images.findIndex(item => String(item.id) === link.dataset.galleryId);
        if (selected < 0) return;
        event.preventDefault(); suppressClickUntil = 0; opener = link;
        const template = dialog.querySelector('[data-gallery-thumbnail-template]');
        if (template) template.replaceWith(template.content.cloneNode(true));
        show(selected);
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden'; dialog.showModal();
        dialog.querySelector('[data-gallery-close]').focus();
        revealThumbnail();
      });
      dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow; setZoom(false); gesture = null;
        product.dispatchEvent(new CustomEvent('fellino:gallery:select',{detail:{mediaId:images[index].id}}));
        const selectedOpener = product.querySelector(`[data-gallery-open][data-gallery-id="${images[index].id}"]`);
        (selectedOpener || opener)?.focus({preventScroll:true});
      });
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('click', event => {
        const thumbnail = event.target.closest('[data-gallery-thumb]');
        if (thumbnail) show(images.findIndex(item => String(item.id) === thumbnail.dataset.galleryThumb));
      });
      const toggleZoom = event => {
        const enabled = !dialog.classList.contains('is-zoomed');
        const rect = image.getBoundingClientRect();
        const x = event?.clientX !== undefined ? (event.clientX - rect.left) / rect.width : .5;
        const y = event?.clientY !== undefined ? (event.clientY - rect.top) / rect.height : .5;
        setZoom(enabled);
        if (enabled) stage.scrollTo(image.clientWidth * x - stage.clientWidth / 2, image.clientHeight * y - stage.clientHeight / 2);
      };
      zoom?.addEventListener('click', () => toggleZoom());
      image.addEventListener('click', event => { if (Date.now() > suppressClickUntil) toggleZoom(event); });
      image.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggleZoom(); }
      });
      dialog.querySelector('[data-gallery-prev]').addEventListener('click', () => show(index - 1));
      dialog.querySelector('[data-gallery-next]').addEventListener('click', () => show(index + 1));
      dialog.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowLeft') next = index - 1;
        if (event.key === 'ArrowRight') next = index + 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = images.length - 1;
        if (next === undefined) return;
        event.preventDefault(); show(next);
        if (event.target.closest('[data-gallery-thumb]')) dialog.querySelector('[data-gallery-thumb][aria-current="true"]')?.focus({preventScroll:true});
      });
      stage.addEventListener('pointerdown', event => {
        endGesture();
        if (!event.isPrimary || event.button !== 0) return;
        gesture={id:event.pointerId,x:event.clientX,y:event.clientY,time:event.timeStamp,
          pan:dialog.classList.contains('is-zoomed'),nativeTouch:event.pointerType==='touch',left:stage.scrollLeft,top:stage.scrollTop,moved:false};
      });
      stage.addEventListener('pointermove', event => {
        if (gesture?.id !== event.pointerId) return;
        const dx=event.clientX-gesture.x,dy=event.clientY-gesture.y;
        if (gesture.pan) {
          if (!gesture.moved && Math.hypot(dx,dy)<4) return;
          gesture.moved=true;
          // Let the browser handle touch panning, including momentum and
          // diagonals. Mouse/pen retain the grab-to-drag interaction.
          if(gesture.nativeTouch){suppressClickUntil=Date.now()+650;return;}
          if(!stage.hasPointerCapture(event.pointerId))stage.setPointerCapture(event.pointerId);
          stage.classList.add('is-panning');
          event.preventDefault();
          stage.scrollLeft=gesture.left-dx; stage.scrollTop=gesture.top-dy;
        } else if (Math.abs(dx)>10 && Math.abs(dx)>Math.abs(dy)*1.3 && !stage.hasPointerCapture(event.pointerId)) stage.setPointerCapture(event.pointerId);
      });
      stage.addEventListener('pointerup', event => {
        if (gesture?.id !== event.pointerId) return;
        const start=endGesture();
        if (start.pan) {
          if (start.moved) suppressClickUntil=Date.now()+600;
          return;
        }
        if (dialog.classList.contains('is-zoomed')) return;
        const dx=event.clientX-start.x,dy=event.clientY-start.y;
        if(Math.abs(dx)>=50&&Math.abs(dx)>Math.abs(dy)*1.3&&event.timeStamp-start.time<1200){suppressClickUntil=Date.now()+600;show(index+(dx<0?1:-1));}
      });
      stage.addEventListener('pointercancel', () => {if(gesture?.moved)suppressClickUntil=Date.now()+600;endGesture();});
      stage.addEventListener('lostpointercapture', event => {
        if(event.target!==stage || gesture?.id!==event.pointerId || stage.hasPointerCapture(event.pointerId))return;
        if(gesture.moved)suppressClickUntil=Date.now()+600;
        endGesture();
      });
      stage.addEventListener('dragstart', event => event.preventDefault());
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
